import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleFuiteDonneesSystemesIA() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="Fuite de données via les systèmes d'IA : comment ça arrive"
      date="8 décembre 2026"
      ctaTitle="Vérifiez l'exposition de vos systèmes d'IA"
      ctaText="Le diagnostic identifie les configurations à risque sur vos systèmes d'IA intégrés."
    >
      <p style={s.intro}>
        Au-delà du cas bien connu d'un salarié qui colle des données confidentielles dans un outil
        conversationnel grand public, la fuite de données peut aussi provenir de systèmes d'IA intégrés à vos
        propres outils, sans qu'aucune erreur humaine directe ne soit en cause.
      </p>

      <h2 style={s.h2}>Des droits d'accès trop larges</h2>
      <p>
        Un assistant IA connecté à votre messagerie, à votre CRM ou à vos documents internes hérite souvent
        des droits d'accès du compte auquel il est rattaché. Si ces droits sont plus larges que nécessaire, le
        système peut accéder — et potentiellement restituer — des données qui n'auraient jamais dû entrer
        dans son périmètre.
      </p>

      <h2 style={s.h2}>Des réponses qui mémorisent plus qu'elles ne devraient</h2>
      <p>
        Certains systèmes conservent un contexte ou un historique entre les sessions pour améliorer leurs
        réponses. Mal configuré, ce mécanisme peut exposer, à un autre utilisateur ou dans une autre session,
        des informations issues d'une conversation précédente.
      </p>

      <h2 style={s.h2}>Des intégrations tierces mal maîtrisées</h2>
      <p>
        Un système d'IA s'appuie souvent sur plusieurs services en chaîne (fournisseur du modèle, plateforme
        d'orchestration, outil de stockage). Chaque maillon de cette chaîne est un point de fuite potentiel si
        sa sécurité n'a pas été vérifiée — voir notre article
        {' '}<Link to="/blog/gestion-fournisseurs-ia" style={s.link}>sur la gestion des fournisseurs IA</Link>.
      </p>

      <h2 style={s.h2}>Des journaux de requêtes conservés sans contrôle</h2>
      <p>
        Les échanges avec un système d'IA sont souvent journalisés à des fins de débogage ou d'amélioration.
        Ces journaux peuvent contenir des données sensibles et doivent être soumis aux mêmes règles de
        sécurité et de conservation que n'importe quelle autre donnée de l'entreprise.
      </p>

      <h2 style={s.h2}>Comment limiter ce risque</h2>
      <p>
        Appliquez le principe du moindre privilège à chaque système d'IA connecté à vos outils, vérifiez la
        durée et le lieu de conservation des journaux, et intégrez ces systèmes dans votre cartographie
        générale de sécurité — voir notre
        {' '}<Link to="/blog/securite-informatique-entreprise-fondamentaux" style={s.link}>article sur les fondamentaux de sécurité informatique</Link>{' '}
        pour les principes transposables à ces systèmes.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleFuiteDonneesSystemesIA;
